import { createStructuredSelector } from 'reselect'

import {
  REQUEST_ECO_LIST,
  REQUEST_ECO_LIST_SUCCESS,
  REQUEST_ECO_LIST_ERROR,
  REQUEST_ECO_PAGE_SET,
  REQUEST_ECO_SEARCH_SET,
  REQUEST_ECO_SEARCH_CHANGE,
  REQUEST_ECO_SEARCH_GEO_COUNTRY_LIST,
  REQUEST_ECO_SEARCH_GEO_COUNTRY_LIST_SUCCESS,
  REQUEST_ECO_SEARCH_GEO_COUNTRY_LIST_ERROR,
  REQUEST_ECO_SEARCH_HEALTH_AGENCY_LIST,
  REQUEST_ECO_SEARCH_HEALTH_AGENCY_LIST_SUCCESS,
  REQUEST_ECO_SEARCH_HEALTH_AGENCY_LIST_ERROR,
  REQUEST_ECO_ADD_SET,
  REQUEST_ECO_ADD_MODAL_SET,
  REQUEST_ECO_ADD,
  REQUEST_ECO_ADD_SUCCESS,
  REQUEST_ECO_ADD_ERROR,
  REQUEST_ECO_ADD_CHANGE,
  REQUEST_ECO_DETAIL,
  REQUEST_ECO_DETAIL_SUCCESS,
  REQUEST_ECO_DETAIL_ERROR,
  REQUEST_ECO_VIEW_MODAL_SET,
  REQUEST_ECO_EDIT_CHANGE,
  REQUEST_ECO_EDIT_MODAL_SET,
  REQUEST_ECO_UPDATE,
  REQUEST_ECO_UPDATE_SUCCESS,
  REQUEST_ECO_UPDATE_ERROR,
  REQUEST_ECO_VIEW_TAB_SET
} from '../actions';

export const NAME = 'request_eco';

export const RequestEcoList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: REQUEST_ECO_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const RequestEcoListSuccess = (data) => ({
  type: REQUEST_ECO_LIST_SUCCESS,
  payload: data
});

export const RequestEcoListError = (error) => ({
  type: REQUEST_ECO_LIST_ERROR,
  payload: error
});

export const RequestEcoPageSet = (data) => ({
  type: REQUEST_ECO_PAGE_SET,
  payload: data
});

export const RequestEcoSearchSet = (data) => ({
  type: REQUEST_ECO_SEARCH_SET,
  payload: data
});

export const RequestEcoSearchChangeSet = (data) => ({
  type: REQUEST_ECO_SEARCH_CHANGE,
  payload: data
});

export const RequestEcoSearchGeoCountryList = (data) => ({
  type: REQUEST_ECO_SEARCH_GEO_COUNTRY_LIST,
  payload: data
});

export const RequestEcoSearchGeoCountryListSuccess = (message) => ({
  type: REQUEST_ECO_SEARCH_GEO_COUNTRY_LIST_SUCCESS,
  payload: message
});

export const RequestEcoSearchGeoCountryListError = (error) => ({
  type: REQUEST_ECO_SEARCH_GEO_COUNTRY_LIST_ERROR,
  payload: error
});

export const RequestEcoSearchHealthAgencyList = (data) => ({
  type: REQUEST_ECO_SEARCH_HEALTH_AGENCY_LIST,
  payload: data
});

export const RequestEcoSearchHealthAgencyListSuccess = (message) => ({
  type: REQUEST_ECO_SEARCH_HEALTH_AGENCY_LIST_SUCCESS,
  payload: message
});

export const RequestEcoSearchHealthAgencyListError = (error) => ({
  type: REQUEST_ECO_SEARCH_HEALTH_AGENCY_LIST_ERROR,
  payload: error
});

export const RequestEcoAddChangeSet = (data) => ({
  type: REQUEST_ECO_ADD_CHANGE,
  payload: data
});

export const RequestEcoAddSet = (data) => ({
  type: REQUEST_ECO_ADD_SET,
  payload: data
});

export const RequestEcoAddModalSet = (data) => ({
  type: REQUEST_ECO_ADD_MODAL_SET,
  payload: data
});

export const RequestEcoAdd = (data) => ({
  type: REQUEST_ECO_ADD,
  payload: data
});

export const RequestEcoAddSuccess = (message) => ({
  type: REQUEST_ECO_ADD_SUCCESS,
  payload: message
});

export const RequestEcoAddError = (error) => ({
  type: REQUEST_ECO_ADD_ERROR,
  payload: error
});

export const RequestEcoDetail = (data) => ({
  type: REQUEST_ECO_DETAIL,
  payload: data
});

export const RequestEcoDetailSuccess = (data) => ({
  type: REQUEST_ECO_DETAIL_SUCCESS,
  payload: data
});

export const RequestEcoDetailError = (error) => ({
  type: REQUEST_ECO_DETAIL_ERROR,
  payload: error
});

export const RequestEcoViewModalSet = (data) => ({
  type: REQUEST_ECO_VIEW_MODAL_SET,
  payload: data
});

export const RequestEcoEditModalSet = (data) => ({
  type: REQUEST_ECO_EDIT_MODAL_SET,
  payload: data
});

export const RequestEcoEditChangeSet = (data) => ({
  type: REQUEST_ECO_EDIT_CHANGE,
  payload: data
});

export const RequestEcoUpdate = (data) => ({
  type: REQUEST_ECO_UPDATE,
  payload: data
});

export const RequestEcoUpdateSuccess = (message) => ({
  type: REQUEST_ECO_UPDATE_SUCCESS,
  payload: message.message
});

export const RequestEcoUpdateError = (error) => ({
  type: REQUEST_ECO_UPDATE_ERROR,
  payload: error
});

export const RequestEcoViewTabSet = (data) => ({
  type: REQUEST_ECO_VIEW_TAB_SET,
  payload: data
});

const request_eco = (state) => state[NAME];

export const RequestEcoSelector = createStructuredSelector({
  request_eco
})
